import { createContext, useContext, type ReactNode } from 'react'
import type { ImpersonationController } from './model/controller'

const Ctx = createContext<ImpersonationController | null>(null)

export function ImpersonationProvider({
  controller,
  children,
}: {
  controller: ImpersonationController
  children: ReactNode
}) {
  return <Ctx.Provider value={controller}>{children}</Ctx.Provider>
}

/** The app's impersonation controller (Frontend §6.4). */
export function useImpersonation(): ImpersonationController {
  const value = useContext(Ctx)
  if (!value) throw new Error('useImpersonation: no ImpersonationProvider')
  return value
}
